<div class="component datepicker-example">
    <h2>Datepicker</h2>
    <div class="example">
        <p>
            Default
        </p>
        <sbw-datepicker></sbw-datepicker>
    </div>
    <div class="example">
        <p>
            Pre-selected date
        </p>
        <sbw-datepicker [(ngModel)]="selectedDate"></sbw-datepicker>
    </div>
    <div class="example">
        <p>
            Using locale
        </p>
        <sbw-datepicker [viewModel]="datepickerViewLocale"></sbw-datepicker>
    </div>
    <div class="example">
        <p>
            Placeholder from viewModel
        </p>
        <sbw-datepicker [viewModel]="datepickerViewPlaceholder"></sbw-datepicker>
    </div>
    <div class="example">
        <p>
            Placeholder from prop
        </p>
        <sbw-datepicker [placeholder]="'Some placeholder text'"></sbw-datepicker>
    </div>
    <div class="example">
        <p>
            No placeholder
        </p>
        <sbw-datepicker [placeholder]="''"></sbw-datepicker>
    </div>
    <div class="example">
        <p>
            Disabled days and with min and max date set
        </p>
        <sbw-datepicker [viewModel]="datepickerViewRestrictDates"></sbw-datepicker>
    </div>
    <div class="example">
        <p>
            Default date
        </p>
        <sbw-datepicker [viewModel]="datepickerViewDefaultDate"></sbw-datepicker>
    </div>
    <div class="example">
        <p>
            Using a year selector
        </p>
        <sbw-datepicker [viewModel]="datepickerViewYearSelector"></sbw-datepicker>
    </div>
    <div class="example">
        <p>
            Selection changed
        </p>
        <sbw-datepicker [(ngModel)]="selectedDateNgModel"></sbw-datepicker>
        <div>
            {{selectedDateNgModel}}
        </div>
    </div>
</div>